import { BaseModel } from '../../app/core/models/base.model';

export class UserLanguage extends BaseModel {
  ShortCode: string = '';
  ISOCode: string = '';
  Title: string = '';
  IsDefault: boolean = false;
}
